export const NAVIGATION_ITEMS = [
  { label: 'Home', href: '#home' },
  { label: 'Company', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Impact', href: '#impact' },
  { label: 'Work', href: '#portfolio' },
  { label: 'Contact', href: '#contact' },
]

// Mobile bottom tab bar — 4 thumb-reachable destinations.
// Icons are lucide-react component names, resolved in BottomNav.
export const BOTTOM_NAV_ITEMS = [
  { id: 'home', label: 'Home', icon: 'Home' },
  { id: 'services', label: 'Services', icon: 'LayoutGrid' },
  { id: 'portfolio', label: 'Work', icon: 'FolderGit2' },
  { id: 'contact', label: 'Contact', icon: 'MessageCircle' },
]

export const FORM_VALIDATION = {
  email: {
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: 'Please enter a valid email address',
  },
  name: {
    minLength: 2,
    maxLength: 50,
    message: 'Name must be between 2 and 50 characters',
  },
  message: {
    minLength: 10,
    maxLength: 500,
    message: 'Message must be between 10 and 500 characters',
  },
}

export const PROJECT_TYPES = [
  'Custom Software',
  'Mobile App',
  'Web Application',
  'API & Integration',
  'Technology Consulting',
  'Cloud & DevOps',
  'Other',
]
